const types = {
    ADD_EMPTY_FIELDS_IDS: "ADD_EMPTY_FIELDS_IDS",
    REMOVE_FIELD: "REMOVE_FIELD",
    ADD_FIELD: "ADD_FIELD"
};

export default types;
